import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { RoutingService } from '../../routing/services/routing.service';
import { SettingsService } from '../../settings/services/settings.service';
import { PermissionService } from './permission.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class AuthGuardService implements CanActivate {
  private userIsLoggedIn = false;
  onRouting = new Subject<boolean>();

  constructor(
    private authService: AuthService,
    private routingService: RoutingService,
    private settingsService: SettingsService,
    private permissionService: PermissionService
  ) {
    this.authService.onLoggedIn.subscribe(
      loggedIn => (this.userIsLoggedIn = loggedIn)
    );
    this.authService.getUserLoginState();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.onRouting.next(true);
    if (!this.authService.accessTokenIsValid()) {
      return this.authService
        .refreshUserLogin()
        .mergeMap(
            response => {
                if (response) {
                    return this.verifyUserHasAccessAfterLogin(this.authService.getuserIsLoggedIn());
                } else {
                    return Observable.of(false);
                }
            }
        );
    }
    const settings = this.settingsService.Get();

    if (!settings.useAuthentication) {
      this.onRouting.next(false);
      return true;
    }

    if (!this.userIsLoggedIn) {
      return this.verifyUserHasAccessAfterLogin(
        this.authService.getuserLoggedIn()
      );
    }
    return this.verifyUserHasAccess();
  }

  private verifyUserHasAccess() {
    return this.permissionService.verifyProductAccess().map(
      (response: any) => {
        if (response) {
          this.onRouting.next(false);
          return true;
        }
        this.onRouting.next(false);
        this.routingService.routeToUnauthorised();
        return false;
      },
      error => {
        console.log(error);
        this.onRouting.next(false);
        this.routingService.routeToUnauthorised();
        return false;
      }
    );
  }

  private verifyUserHasAccessAfterLogin(loggedIn: Observable<any>) {
    return loggedIn.mergeMap(response => {
      if (response) {
        return this.verifyUserHasAccess();
      }
      this.onRouting.next(false);
      this.routingService.routeToUnauthorised();
      return Observable.of(false);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/services/auth-guard.service.ts